import styled from '@emotion/styled';
import { css } from 'emotion';

import { getThemeColor, theme } from '@ezugi/ui/theme';

import { CELL_BORDER_COLOR, DEFAULT_CELL_SIZE } from './constants';

export const Container = styled.div`
  background: ${getThemeColor('primary', theme.tints.primary)};
  width: ${(props) => props.size || DEFAULT_CELL_SIZE}px;
  height: ${(props) => props.size || DEFAULT_CELL_SIZE}px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  text-align: center;
  font-weight: bold;

  border-bottom: 1px solid ${CELL_BORDER_COLOR};
  border-right: 1px solid ${CELL_BORDER_COLOR};

  &:nth-child(-n + 7) {
    border-left: 1px solid ${CELL_BORDER_COLOR};
  }
  &:nth-child(7n + 1) {
    border-top: 1px solid ${CELL_BORDER_COLOR};
  }

  min-width: ${(props) => props.size || DEFAULT_CELL_SIZE}px;
  min-height: ${(props) => props.size || DEFAULT_CELL_SIZE}px;

  [lang=ko] &,
  [lang=hi] & {
    width: ${(props) => props.size || DEFAULT_CELL_SIZE + 1}px;
    height: ${(props) => props.size || DEFAULT_CELL_SIZE + 1}px;
    font-size: 10px;
    line-height: 10px;
  }
`;

export const tripleClassName = css`
  color: #ce1822;
`;

export const bigClassName = css`
  color: #1a5dc6;
`;

export const evenClassName = css`
  color: #1a5dc6;
`;

export const smallClassName = css`
  color: #9ca8c2;
`;

export const oddClassName = css`
  color: #9ca8c2;
`;
